// extracted by mini-css-extract-plugin
export default {"navbarHideable":"navbarHideable_jvwV","navbarHidden":"navbarHidden_nLSi"};